import {EventEmitter} from "events";
import {apiEndpoint} from '@/services/endpoints';
import {AuthService} from "@/services/AuthService";
import {logBus} from "@/services/logBus";
import {ApiCaller} from "@/services/ApiCaller";
import {ErrorHandling} from "@/services/errorHandling";
import {NotificationsService} from "@/services/NotificationsService";
import {PWAInstallerService} from '@/services/PWAInstallerService';
import {AndroidHandler} from "@/services/androidKeyboardHandler";

export const authService = new AuthService();

export const notificationsService = new NotificationsService();

export const pwaInstallerService = new PWAInstallerService();

export const uiBus = new EventEmitter();

export const apiCaller = new ApiCaller(
  authService,
  apiEndpoint(),
  logBus,
);

export const androidHandler = new AndroidHandler();

export const errorHandler = new ErrorHandling();
